import { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UserTable from "./table";
import AddEditTerm from "./add-edit-term";
import { useTranslation } from "react-i18next";
import { oneBranchHasPermission } from "src/utils";
import { SettingsPermissions } from "src/constants/permissions";
import { useGetTermsList } from "src/api/sales/invoices";

const InvoiceSettings = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("addSales");

  // APIs
  const { data, isLoading, refetch } = useGetTermsList();

  // permissions
  const addUserPermission = oneBranchHasPermission(SettingsPermissions.addUser);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={3}
      >
        <Typography fontWeight={600} lineHeight={"19.2px"} color={"#475467"}>
          {t("terms")}
        </Typography>
        {addUserPermission && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpen}
          >
            {t("addTerm")}
          </Button>
        )}
      </Stack>
      <UserTable
        termsList={data?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
      {open && (
        <AddEditTerm open={open} handleClose={handleClose} refetch={refetch} />
      )}
    </Stack>
  );
};

export default InvoiceSettings;
